import { render, staticRenderFns } from "./AssignmentAddUpdate.vue?vue&type=template&id=6b56675a&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./AssignmentAddUpdate.vue?vue&type=script&lang=js"
export * from "./AssignmentAddUpdate.vue?vue&type=script&lang=js"
import style0 from "./AssignmentAddUpdate/scoped.css?vue&type=style&index=0&id=6b56675a&prod&scoped=true&lang=css&external"
import style1 from "./AssignmentAddUpdate/global.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b56675a",
  null
  
)

export default component.exports